import React, { useMemo } from 'react'

//* HOC's
import { withDataContext } from 'context'

//* Components
import Page from 'components/common/Page'
import Container from 'components/common/Container'
import HeroSection from 'components/pages/Home/sections/HeroSection'
import AboutSection from 'components/pages/Home/sections/AboutSection'
import FollowersSection from 'components/pages/Home/sections/FollowersSection'
import RunningText from 'components/pages/Home/sections/RunningText'
import NewsSection from 'components/pages/Home/sections/NewsSection'
import AppSection from 'components/pages/Home/sections/AppSection'
import ShopSection from 'components/pages/Home/sections/ShopSection'

const Home = ({ pages, pageParams, selectedLang, global }) => {
	//! Page data
	const pageData = useMemo(() => pages?.[pageParams?.name]?.[selectedLang], [pages, pageParams, selectedLang])

	//! Global data
	const globalData = useMemo(() => global?.[selectedLang], [global, selectedLang])

	return pageData ? (
		<Page>
			<Container>
				<HeroSection
					globalData={globalData}
					videoFirst={pageData.content.top_section_video_1}
					videoSecond={pageData.content.top_section_video_2}
				/>
				<AboutSection />
				<FollowersSection socials={globalData?.socials} />
				{/* <ShopSection products={pageData?.products} /> */}
			</Container>
			<RunningText youtubeLink={globalData?.socials.youtube.link} />
			<Container>
				<NewsSection newsItems={pageData?.posts} />
				<AppSection appData={pageData?.content} appVideo={pageData?.content.app_video} />
			</Container>
		</Page>
	) : null
}

export default withDataContext(Home, ['pages', 'global'])
